/* eslint-disable */
import React from 'react';
import { Row, Col, Container, Card, CardBody } from 'reactstrap';

import img1 from '../../assets/images/testimonial/1.jpg';
import img2 from '../../assets/images/testimonial/2.jpg';
import img3 from '../../assets/images/testimonial/3.jpg';

const HowItWorks = () => {
    return (
        <div>

            <div className="testimonial3 spacer bg-light">
                <Container>
                    <Row className="justify-content-center">
                        <Col md="7" className="text-center">
                            <h1 className="title font-bold">How It Works!</h1>
                            <h6 className="subtitle">Here are the steps you have to follow. Its quite easy to extract text in No-time.</h6>
                        </Col>
                  
                    </Row>
                    <Row className="testi3 m-t-40 justify-content-center">
                        <Col lg="4" md="6">
                            <Card className="card-shadow">
                                <CardBody>
                                    <h6 className="font-light m-b-30">First of all open our website Convext.</h6>
                                    <div className="d-flex no-block align-items-center">
                                        <div>
                                            <h6 className="m-b-0 customer">Step 1</h6>
                                        </div>
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>
                        <Col lg="4" md="6">
                            <Card className="card-shadow">
                                <CardBody>
                                    <h6 className="font-light m-b-30">In services section choose a service.</h6>
                                    <div className="d-flex no-block align-items-center">
                                        <div>
                                            <h6 className="m-b-0 customer">Step 2</h6>
                                        </div>
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>
                        <Col lg="4" md="6">
                            <Card className="card-shadow">
                                <CardBody>
                                    <h6 className="font-light m-b-30">Choose a file you want to extract text from.</h6>
                                    <div className="d-flex no-block align-items-center">
                                        <div>
                                            <h6 className="m-b-0 customer">Step 3</h6>
                                        </div>
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>
                        <Col lg="4" md="6">
                            <Card className="card-shadow">
                                <CardBody>
                                    <h6 className="font-light m-b-30">After choosing file press extract button and wait.</h6>
                                    <div className="d-flex no-block align-items-center">
                                        <div>
                                            <h6 className="m-b-0 customer">Step 4</h6>
                                        </div>
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>
                        <Col lg="4" md="6">
                            <Card className="card-shadow">
                                <CardBody>
                                    <h6 className="font-light m-b-30">Once text is extracted you see extracted text in editor.</h6>
                                    <div className="d-flex no-block align-items-center">
                                        <div>
                                            <h6 className="m-b-0 customer">Step 5</h6>
                                        </div>
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>
                        <Col lg="4" md="6">
                            <Card className="card-shadow">
                                <CardBody>
                                    <h6 className="font-light m-b-30">Now you can edit and download it as pdf or document.</h6>
                                    <div className="d-flex no-block align-items-center">
                                        <div>
                                            <h6 className="m-b-0 customer">Step 6</h6>
                                        </div>
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>
                    
                    </Row>
                </Container>
            </div>
        </div>
    );
}

export default HowItWorks;
